<template>
  <div class="installments">
    <div class="installment" v-for="installment in installments" :key="installment.name" @click="onClick(installment)">
      <div class="info">
        <div class="name" v-if="installment.name">{{ installment.name }}</div>
        <img class="name" v-else-if="installment.icon" :src="installment.icon" />
        <div class="label" v-html="installment.label"></div>
      </div>
      <div class="chevron">
        <!-- TODO: Replace with IconUi name="navigation/chevron-right_line" from @/shared/legacy-kit when available -->
        ➡️
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IInstallment } from '../../models/installment';

// TODO: Replace with IconUi from @/shared/legacy-kit when available

interface Props {
  installments: IInstallment[];
}

interface Emits {
  (e: 'installmentClick', installment: IInstallment): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const onClick = (installment: IInstallment) => {
  emit('installmentClick', installment);
};
</script>
<style lang="stylus" scoped>
.installments
  display flex
  column-gap 12px
  .installment
    border-radius 12px
    border 1px solid Gray(LT44)
    padding 14px 12px 14px 16px
    display flex
    flex 1
    cursor pointer
    justify-content space-between
    .info
      .name
        font-weight 400
        font-size 13px
        line-height 16px
        letter-spacing -0.01em
        color #000
        margin-bottom 4px
      img.name
        max-width 100%
        height 16px
        margin-bottom 2px
      .label
        font-weight 600
        font-size 13px
        line-height 16px

        letter-spacing -0.01em

        color #141415
    .chevron
      margin auto 0
      >>> .ui-icon path
        fill Gray(A50)
</style>
